import schemaLdJson from 'src/seo/schemaLdJson'

export default class extends schemaLdJson {
  constructor($this) {
    super($this)
    this.$this = $this
  }

  generate() {
    const $this = this.$this

    const json = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      url: `${this.URL}${$this.$route.fullPath}`,
      name: this.$this.competition.name,
      // "datePublished": this.$this.competition.dateStart,
      // "dateModified": this.$this.competition.dateStart,
      description: this.$this.competition.shortDescription,

      isPartOf: this.isPartOf(),

      primaryImageOfPage: this.logo(),

      publisher: this.publisher(),

      mainEntity: {
        '@type': 'Article',
        name: this.$this.competition.name,
        // "datePublished": this.seoData?.created,
        // "dateModified": this.seoData?.updated,
        headline: this.parseHeadline($this.competition.description),
        author: this.authorCasino(),

        publisher: this.publisher(),
      },

      breadcrumb: this.breadcrumb([
        {
          '@type': 'WebPage',
          '@id': `${this.URL}${$this.$route.fullPath}`,
          name: `👇${this.$this.competition.name}`,
        },
      ]),
    }

    return JSON.stringify(json)
  }
}
